import { $ } from "glamor";
import { theme } from "styles/theme";

export const getStyleMergeMixin = () => [
    $(" .mention", {
        color: theme.palette.accent2Color,
        display: "inline-block",
        paddingLeft: "2px",
        paddingRight: "2px",
        borderRadius: "2px",
        textDecoration: "none",
    }),
    $(" .mentionSuggestions", {
        border: "1px solid #eee",
        marginTop: "0.4em",
        position: "absolute",
        minWidth: "220px",
        maxWidth: "440px",
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0px 4px 30px 0px rgba(220,220,220,1)",
        cursor: "pointer",
        paddingTop: "8px",
        paddingBottom: "8px",
        zIndex: 200,
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        transform: "scale(0)",
    }),
    $(" .mentionSuggestionsEntry", {
        padding: "7px 10px 3px 10px",
        transition: "background-color 0.4s cubic-bezier(.27,1.27,.48,.56)",
    }),
    $(" .mentionSuggestionsEntry:active", {
        backgroundColor: "#cce7ff",
    }),
    $(" .mentionSuggestionsEntryFocused", {
        padding: "7px 10px 3px 10px",
        transition: "background-color 0.4s cubic-bezier(.27,1.27,.48,.56)",
        backgroundColor: "#e6f3ff",
    }),
    $(" .mentionSuggestionsEntryText", {
        display: "inline-block",
        marginLeft: "8px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "368px",
        fontSize: "0.9em",
        marginBottom: "0.2em",
    }),
];
